module.exports = __webpack_public_path__ + "static/coo-dab55b4adfe62f271d9687f1cce85f37.png";